const ALL = [
  { id: "ipo", label: "Since IPO", hint: "Inception → today" },
  { id: "since_2020", label: "2020 — Now", hint: "Jan 1, 2020 → today" },
  { id: "fy2025", label: "FY 2025", hint: "Jan 1 → Dec 31, 2025" },
  { id: "ytd", label: "Current YTD", hint: "Jan 1 this yr → today" },
];

const MAX = 4;

export default function IntervalSelector({ value, onChange, ipoDate }) {
  const toggle = (id) => {
    if (value.includes(id)) {
      onChange(value.filter((v) => v !== id));
    } else {
      if (value.length >= MAX) return;
      onChange([...value, id]);
    }
  };

  return (
    <div data-testid="interval-selector" className="grid grid-cols-2 md:grid-cols-4 gap-2">
      {ALL.map((it) => {
        const active = value.includes(it.id);
        const dimmed = !active && value.length >= MAX;
        return (
          <button
            key={it.id}
            data-testid={`interval-toggle-${it.id}`}
            onClick={() => toggle(it.id)}
            disabled={dimmed}
            className={[
              "text-left p-4 border transition-colors",
              active
                ? "bg-white text-black border-white"
                : "bg-transparent border-zinc-800 text-zinc-300 hover:border-zinc-500 hover:text-white",
              dimmed ? "opacity-30 cursor-not-allowed" : "",
            ].join(" ")}
          >
            <div className="font-bold text-sm tracking-tight">{it.label}</div>
            <div
              className={`text-[10px] font-mono uppercase tracking-widest mt-1 ${
                active ? "text-black/70" : "text-zinc-500"
              }`}
            >
              {it.id === "ipo" && ipoDate ? `from ${ipoDate}` : it.hint}
            </div>
          </button>
        );
      })}
    </div>
  );
}
